var user_object = {
    user: null
    //{
    //    email: "lventer@aculocity.com",
    //    email_verified: true,
    //    updated_at: "2016-05-09T06:57:22.707Z",
    //    picture: "https://s.gravatar.com/avatar/6be5bc403951b3c72eefa5a43796f07f?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Flv.png",
    //    user_id: "auth0|571f3e924247998a66726d41",
    //    name: "lventer@aculocity.com",
    //    given_name: "Luan",
    //    family_name: "Venter",
    //    nickname: "lventer",
    //    identities: [
    //        {
    //            user_id: "571f3e924247998a66726d41",
    //            provider: "auth0",
    //            connection: "Username-Password-Authentication",
    //            isSocial: false
    //        }
    //    ],
    //    created_at: "2016-04-26T10:10:26.322Z",
    //    user_metadata: {
    //        zip: ""
    //    },
    //    last_password_reset: "2016-05-06T06:51:29.212Z",
    //    app_metadata: {
    //        OES: {
    //            name: "OES",
    //            description: "Owner Empowered Services",
    //            icon: "images/app_icons/qms.png",
    //            identifier: "oes",
    //            active: true,
    //            userID: "some string",
    //            claims: [
    //                "SomeClaim",
    //                "SomeOtherClaim"
    //            ]
    //        },
    //        QMS: {
    //            name: "QMS",
    //            description: "Quality Management System",
    //            icon: "images/app_icons/direct-service.png",
    //            identifier: "qms",
    //            active: true,
    //            userID: "some string",
    //            claims: [
    //                "PracClaim",
    //                "SomePracOtherClaim"
    //            ]
    //        },
    //        Framework: {
    //            name: "Framework",
    //            description: "Autocar Portal Framework",
    //            icon: "images/app_icons/styleguide.png",
    //            identifier: "framework",
    //            active: true,
    //            userID: "some string",
    //            claims: [
    //                "PracClaim",
    //                "SomePracOtherClaim"
    //            ]
    //        }
    //    },
    //    last_ip: "129.205.129.178",
    //    last_login: "2016-05-06T13:35:16.622Z",
    //    logins_count: 56,
    //    blocked_for: []
    //}
    ,
    messages: [
      {
          id: 1,
          date: "06/01/2016 10:22",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "EPC",
          first_name: "Bridgett",
          last_name: "Goodwin",
          title: "Ad commodo consequat quis non voluptate aliqua.",
          message: "Est est qui pariatur proident commodo ad deserunt sint qui in minim. Do ullamco eu proident duis mollit consectetur deserunt voluptate labore ex sint in ullamco sunt. Voluptate voluptate officia deserunt aliquip eiusmod amet occaecat voluptate proident amet culpa labore est. Ea est sint ea esse non ea incididunt consequat culpa cupidatat ea. Culpa velit minim culpa excepteur nisi voluptate commodo reprehenderit nisi pariatur aliquip ad in. Nisi in eu tempor ipsum. Consectetur amet duis commodo voluptate do nisi ad in amet exercitation.\r\n"
      },
      {
          id: 2,
          date: "25/01/2016 11:13",
          origin: "User",
          type: "Chat",
          flag: "Viewed",
          application: "Prac",
          first_name: "Weber",
          last_name: "Puckett",
          title: "Dolore anim non do aliqua tempor ut tempor reprehenderit.",
          message: "Ex cillum sit anim incididunt eiusmod aliqua esse ut duis. Pariatur culpa Lorem et eu et nostrud. Irure sint excepteur voluptate ullamco do velit eiusmod labore dolor eiusmod eiusmod ex do. Irure qui aliquip esse nostrud. Enim labore exercitation esse duis.\r\n"
      },
      {
          id: 3,
          date: "08/02/2016 01:51",
          origin: "User",
          type: "Message",
          flag: "New",
          application: "Prac",
          first_name: "Blanche",
          last_name: "Mckinney",
          title: "Nulla enim irure proident et.",
          message: "Quis nulla amet elit non esse ea amet reprehenderit duis ipsum velit mollit est nostrud. Aute elit velit incididunt dolor commodo anim. Incididunt minim nulla qui cupidatat adipisicing. Tempor voluptate sit dolor consectetur. Eu non excepteur culpa laborum labore.\r\n"
      },
      {
          id: 4,
          date: "03/02/2016 12:54",
          origin: "Application",
          type: "Message",
          flag: "New",
          application: "Direct Service",
          first_name: "Rose",
          last_name: "Sweeney",
          title: "Elit fugiat pariatur exercitation aute.",
          message: "Esse reprehenderit culpa quis ullamco. Nulla do nisi aliqua veniam. Laboris eu esse dolore nostrud exercitation aute. Excepteur sit non adipisicing fugiat.\r\n"
      },
      {
          id: 5,
          date: "24/01/2016 03:16",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "EPC",
          first_name: "Louisa",
          last_name: "Key",
          title: "Commodo aliquip aliqua irure ut esse in magna adipisicing qui.",
          message: "Irure do Lorem voluptate labore sint nostrud excepteur eiusmod officia laborum et quis Lorem nulla. Commodo deserunt culpa consequat ipsum magna enim consectetur amet tempor proident aliquip aute tempor. Elit consequat pariatur veniam ex fugiat esse veniam Lorem veniam laboris ullamco eiusmod ullamco. Nisi do adipisicing velit quis nulla adipisicing do veniam ad. Anim aliquip aliquip nulla laboris aliqua velit anim sint nostrud magna.\r\n"
      },
      {
          id: 6,
          date: "10/01/2016 07:22",
          origin: "Application",
          type: "Message",
          flag: "Viewed",
          application: "EPC",
          first_name: "Alston",
          last_name: "Atkins",
          title: "Ut dolore aute aute enim id esse.",
          message: "Qui deserunt non excepteur adipisicing ipsum duis exercitation. Cupidatat id sint dolore cillum pariatur quis commodo voluptate irure dolor ullamco. Cupidatat in cillum adipisicing excepteur. Anim deserunt ex ea ea adipisicing reprehenderit deserunt eu in labore ipsum. Eu fugiat magna amet enim commodo consequat exercitation ullamco laboris eu minim consequat. Culpa nostrud occaecat culpa magna sit dolor eiusmod quis commodo laborum tempor aliquip incididunt labore.\r\n"
      },
      {
          id: 7,
          date: "21/01/2016 01:58",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "Direct Service",
          first_name: "Potts",
          last_name: "Rosa",
          title: "Adipisicing et aliqua ut irure do anim in.",
          message: "In magna mollit eu et labore. Ut in id aute reprehenderit ipsum ex irure officia do id. Id ipsum voluptate nostrud amet.\r\n"
      },
      {
          id: 8,
          date: "19/02/2016 07:05",
          origin: "User",
          type: "Message",
          flag: "New",
          application: "QMS",
          first_name: "Frances",
          last_name: "Robertson",
          title: "Elit tempor consequat ad nisi quis cupidatat ex nulla in deserunt quis.",
          message: "Reprehenderit pariatur non velit exercitation mollit eiusmod exercitation ea. Et velit magna aliquip culpa irure elit sit laboris commodo cupidatat cupidatat ad do duis. Excepteur elit sit labore pariatur laboris id. Excepteur eiusmod sit aliquip reprehenderit non laboris elit enim voluptate voluptate mollit. Ad et amet dolor ea exercitation consectetur tempor non. Quis pariatur ullamco magna proident officia fugiat ullamco voluptate cillum aliquip.\r\n"
      },
      {
          id: 9,
          date: "26/01/2016 02:26",
          origin: "Application",
          type: "Chat",
          flag: "Viewed",
          application: "QMS",
          first_name: "Daniel",
          last_name: "Cameron",
          title: "Commodo labore laboris quis ut pariatur reprehenderit duis fugiat id.",
          message: "Tempor incididunt magna eu minim cillum Lorem anim do. Aute eu exercitation cillum eiusmod laboris dolore pariatur elit non aliqua voluptate. Nisi nostrud eiusmod reprehenderit qui.\r\n"
      },
      {
          id: 10,
          date: "22/01/2016 02:37",
          origin: "User",
          type: "Chat",
          flag: "New",
          application: "EPC",
          first_name: "Wooten",
          last_name: "Chang",
          title: "Sit excepteur nisi aute sint ex occaecat est reprehenderit ullamco proident aliquip.",
          message: "Fugiat sit ad magna officia exercitation consectetur anim laborum id qui. Quis aute nisi laborum irure aute ea ipsum Lorem excepteur magna velit anim dolor nulla. Irure labore enim ad reprehenderit dolore laborum esse mollit. Nisi laboris sint dolor ea tempor reprehenderit excepteur do do mollit amet.\r\n"
      },
      {
          id: 11,
          date: "04/01/2016 05:01",
          origin: "User",
          type: "Message",
          flag: "Viewed",
          application: "Prac",
          first_name: "Estela",
          last_name: "Schultz",
          title: "Aliqua amet deserunt dolor cupidatat pariatur et qui quis laboris proident non sit veniam non.",
          message: "Eu fugiat cupidatat occaecat Lorem irure consectetur veniam dolore velit quis ea. Do Lorem deserunt culpa dolor est excepteur amet occaecat amet fugiat aliquip Lorem irure. Deserunt commodo consectetur aliquip dolore irure laboris labore consectetur tempor est sunt magna.\r\n"
      },
      {
          id: 12,
          date: "27/01/2016 02:20",
          origin: "Application",
          type: "Chat",
          flag: "Viewed",
          application: "EPC",
          first_name: "Mccarthy",
          last_name: "Ballard",
          title: "Nostrud voluptate nisi elit ex consequat laborum dolore.",
          message: "Duis consectetur ad in veniam. Anim aute nostrud excepteur ipsum officia velit eiusmod esse id. Commodo nostrud enim sint est incididunt deserunt pariatur aliquip culpa Lorem quis adipisicing elit incididunt. Nulla mollit excepteur veniam laboris cillum mollit consectetur dolore dolore consectetur do aliqua excepteur culpa. Consequat minim cillum magna dolore non et occaecat. Esse Lorem pariatur cillum anim occaecat.\r\n"
      },
      {
          id: 13,
          date: "10/01/2016 09:14",
          origin: "Application",
          type: "Message",
          flag: "Viewed",
          application: "Solutions",
          first_name: "Angela",
          last_name: "Hampton",
          title: "Dolore elit nisi Lorem esse.",
          message: "Cupidatat pariatur laboris incididunt deserunt et reprehenderit nulla. Ad pariatur laborum do excepteur occaecat culpa esse do aliqua deserunt id excepteur reprehenderit et. Officia laborum enim aliquip voluptate laboris et cillum laborum. Pariatur non aliqua veniam consectetur officia eu tempor mollit cupidatat magna reprehenderit veniam. Cupidatat anim tempor veniam exercitation incididunt sunt sunt est sint ea dolore sunt magna do. In esse minim consequat esse veniam esse in non dolor consectetur.\r\n"
      },
      {
          id: 14,
          date: "28/01/2016 07:48",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "Prac",
          first_name: "Jessie",
          last_name: "George",
          title: "Cupidatat occaecat esse fugiat enim ex non deserunt dolor consectetur.",
          message: "Consectetur pariatur ullamco irure ullamco nulla qui voluptate consequat ipsum et sit magna eiusmod. Ex aute ipsum consectetur id adipisicing. Amet labore laborum excepteur consectetur. Do pariatur est non amet. Lorem aliqua culpa qui eiusmod veniam sit voluptate dolore minim id sint excepteur.\r\n"
      },
      {
          id: 15,
          date: "30/01/2016 10:33",
          origin: "Application",
          type: "Notification",
          flag: "Viewed",
          application: "QMS",
          first_name: "Bridget",
          last_name: "Henderson",
          title: "Dolore dolore sint ad amet officia.",
          message: "Ipsum duis ea velit sit consectetur. Ullamco amet proident culpa exercitation exercitation aute voluptate dolor elit culpa est sit. Incididunt commodo deserunt sunt esse consequat et pariatur sunt quis qui. Mollit veniam sit magna esse aute in elit ullamco reprehenderit minim ea dolore ullamco duis. Adipisicing adipisicing elit officia quis. Labore non consectetur nostrud Lorem laborum. Dolore dolore eu cupidatat aute nostrud enim in nostrud Lorem commodo ea veniam.\r\n"
      },
      {
          id: 16,
          date: "06/02/2016 12:26",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "QMS",
          first_name: "Palmer",
          last_name: "Hicks",
          title: "Sint mollit enim sit culpa consectetur enim.",
          message: "Id ea aliqua do reprehenderit quis ex ut Lorem amet enim adipisicing laboris ullamco. Lorem laborum aliqua magna incididunt. Cupidatat sit deserunt veniam anim. Esse ullamco duis culpa aliquip in. Exercitation ipsum est minim quis dolore laborum incididunt mollit veniam excepteur id exercitation.\r\n"
      },
      {
          id: 17,
          date: "06/01/2016 01:26",
          origin: "User",
          type: "Chat",
          flag: "New",
          application: "Solutions",
          first_name: "Francine",
          last_name: "Vinson",
          title: "Enim esse consequat labore sint sunt ipsum adipisicing velit occaecat.",
          message: "Quis id consectetur laboris ex. Proident anim id dolor sunt. Aliquip non in elit duis aliquip ex labore velit dolore anim et deserunt.\r\n"
      },
      {
          id: 18,
          date: "31/01/2016 04:57",
          origin: "Application",
          type: "Message",
          flag: "Viewed",
          application: "Direct Service",
          first_name: "Schroeder",
          last_name: "David",
          title: "Cupidatat culpa Lorem commodo officia.",
          message: "Lorem sint deserunt dolore est exercitation exercitation tempor adipisicing et culpa. Velit labore magna pariatur excepteur velit est ullamco commodo deserunt mollit ad in sunt. Non occaecat deserunt consequat dolor tempor adipisicing amet duis reprehenderit elit.\r\n"
      },
      {
          id: 19,
          date: "14/01/2016 06:57",
          origin: "Application",
          type: "Chat",
          flag: "New",
          application: "Prac",
          first_name: "Trisha",
          last_name: "Davidson",
          title: "Cillum nostrud eu laboris et adipisicing sunt officia.",
          message: "Laborum exercitation et veniam laboris pariatur cillum quis id eu. Occaecat consectetur voluptate qui ad ad aute et incididunt commodo laboris mollit laboris. Cillum magna exercitation incididunt sunt officia. Enim pariatur eu et do dolore anim velit ea proident enim sint. Ea culpa voluptate ea sit nulla ea adipisicing.\r\n"
      },
      {
          id: 20,
          date: "21/01/2016 07:35",
          origin: "User",
          type: "Chat",
          flag: "Viewed",
          application: "Prac",
          first_name: "Nielsen",
          last_name: "Guerra",
          title: "Cupidatat elit duis occaecat anim ex excepteur officia aliquip ex.",
          message: "Nulla fugiat velit laboris ullamco enim aute. Cillum amet laboris mollit ut cillum duis aliqua ullamco tempor qui velit. Mollit Lorem aliquip cupidatat ad cupidatat ipsum duis reprehenderit aute tempor exercitation adipisicing. Dolor exercitation duis commodo sint excepteur.\r\n"
      },
      {
          id: 21,
          date: "29/01/2016 08:36",
          origin: "User",
          type: "Message",
          flag: "Viewed",
          application: "Solutions",
          first_name: "Griffith",
          last_name: "Gamble",
          title: "In culpa qui qui labore.",
          message: "Ad ad laborum eu duis amet voluptate consequat minim aute anim esse nostrud mollit. Non qui exercitation elit eiusmod. Laborum nulla ullamco pariatur ex pariatur occaecat sint voluptate quis.\r\n"
      },
      {
          id: 22,
          date: "07/02/2016 04:46",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "EPC",
          first_name: "Zimmerman",
          last_name: "Moreno",
          title: "Id pariatur elit sint aliquip sunt aliqua occaecat proident tempor qui.",
          message: "Sit do ad aliquip non deserunt enim cupidatat mollit. Anim quis dolor non sint est proident. Nulla et esse mollit cillum elit dolore deserunt fugiat exercitation sunt aliquip et sit anim. Consectetur Lorem ullamco aliqua et nisi officia anim esse sit minim sint. Ut nostrud veniam laboris fugiat cillum deserunt dolor ex duis mollit amet nulla.\r\n"
      },
      {
          id: 23,
          date: "01/02/2016 09:44",
          origin: "User",
          type: "Notification",
          flag: "New",
          application: "Solutions",
          first_name: "Fay",
          last_name: "Lawrence",
          title: "Nulla minim mollit adipisicing occaecat.",
          message: "Reprehenderit in nulla ipsum consectetur do irure irure veniam labore nisi. Adipisicing velit sunt culpa commodo exercitation elit deserunt excepteur nisi mollit incididunt. Incididunt non anim sint cillum adipisicing aliqua aliqua eiusmod. Lorem duis quis exercitation duis qui est nulla sunt ea. Ut nisi id qui nulla fugiat cillum exercitation adipisicing exercitation deserunt enim officia ea culpa. Proident magna aute aliqua et exercitation ea.\r\n"
      },
      {
          id: 24,
          date: "22/01/2016 08:29",
          origin: "Application",
          type: "Message",
          flag: "Viewed",
          application: "Warranty",
          first_name: "Burke",
          last_name: "Harper",
          title: "Adipisicing fugiat cupidatat consectetur pariatur sint nostrud nostrud laboris.",
          message: "Commodo sint laborum tempor dolor nisi officia culpa incididunt cillum eu amet eiusmod aliqua. Eu aliquip est veniam pariatur elit eu non consectetur enim. Voluptate dolore exercitation eu officia ad cillum minim minim ut.\r\n"
      },
      {
          id: 25,
          date: "11/01/2016 10:12",
          origin: "Application",
          type: "Notification",
          flag: "Viewed",
          application: "Warranty",
          first_name: "Ivy",
          last_name: "Bonner",
          title: "Et velit cupidatat magna eiusmod ex nisi et est mollit excepteur.",
          message: "Id exercitation esse ea voluptate id officia. Occaecat nostrud anim enim officia voluptate ad amet minim ut quis. Ullamco officia esse aute nulla. Consequat veniam mollit dolor occaecat incididunt esse consequat occaecat esse et enim dolore incididunt ad. Laborum est sit excepteur ut aliquip exercitation duis labore. Dolore ex sit proident enim minim culpa ex. Adipisicing nostrud ad in quis labore magna cillum et amet in.\r\n"
      },
      {
          id: 26,
          date: "05/01/2016 07:36",
          origin: "User",
          type: "Notification",
          flag: "New",
          application: "QMS",
          first_name: "Elena",
          last_name: "Hunter",
          title: "Et aute nisi qui nulla laboris voluptate labore occaecat sint aliquip.",
          message: "Dolore aliqua dolor ex aliqua Lorem eiusmod officia pariatur adipisicing. Non esse ut mollit aute consectetur. Laborum ut dolor laborum sit proident aute.\r\n"
      },
      {
          id: 27,
          date: "12/01/2016 12:19",
          origin: "Application",
          type: "Chat",
          flag: "Viewed",
          application: "QMS",
          first_name: "Liz",
          last_name: "Delacruz",
          title: "Sunt cillum esse labore sit sit do aliquip ut reprehenderit nisi labore duis proident.",
          message: "Magna enim eu labore eu dolore eu dolore dolor proident cupidatat. Excepteur exercitation fugiat aliquip minim voluptate anim. Consequat dolor sint tempor cillum ea exercitation nisi quis qui cupidatat irure nostrud. Lorem eu fugiat dolore sit eu ex labore reprehenderit eiusmod pariatur. Ad id ad ea tempor deserunt ea id exercitation ullamco ea pariatur id nulla. Dolore velit tempor ullamco laboris cupidatat.\r\n"
      },
      {
          id: 28,
          date: "13/01/2016 04:36",
          origin: "User",
          type: "Notification",
          flag: "Viewed",
          application: "QMS",
          first_name: "Huber",
          last_name: "Hodge",
          title: "Cillum ut aute ullamco eu.",
          message: "Consectetur proident sint esse est nostrud cupidatat eiusmod aliqua. Aliquip exercitation consequat enim aliqua commodo excepteur labore. Sunt sint excepteur excepteur amet anim consectetur deserunt ipsum mollit enim. Dolor esse deserunt labore voluptate nisi laboris culpa nulla dolore minim. Aliquip tempor qui ipsum aliqua fugiat.\r\n"
      },
      {
          id: 29,
          date: "01/01/2016 12:40",
          origin: "Application",
          type: "Notification",
          flag: "Viewed",
          application: "Solutions",
          first_name: "Kaitlin",
          last_name: "Richards",
          title: "Incididunt esse aute quis qui deserunt mollit nulla laboris.",
          message: "Ea ut laboris ea sint cillum Lorem adipisicing ut proident. Quis proident exercitation sint ut tempor nostrud ad non est cupidatat esse fugiat. Esse sint dolor reprehenderit sunt ea voluptate ullamco nostrud veniam duis do commodo sunt.\r\n"
      },
      {
          id: 30,
          date: "01/02/2016 06:11",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "Solutions",
          first_name: "Barnes",
          last_name: "Livingston",
          title: "Ut qui labore ullamco proident nostrud minim.",
          message: "Irure consequat fugiat commodo ut labore. Amet anim magna amet Lorem do officia Lorem ullamco laboris officia consectetur aliquip deserunt. Ut irure laborum adipisicing proident nulla in sint quis dolore mollit quis aute magna. In quis Lorem tempor laborum aliquip sint sunt laboris pariatur. Officia dolore consectetur sint labore officia in anim exercitation ullamco fugiat duis proident id. Ullamco sint nulla deserunt officia dolore amet.\r\n"
      },
      {
          id: 31,
          date: "03/02/2016 01:26",
          origin: "User",
          type: "Message",
          flag: "Viewed",
          application: "Warranty",
          first_name: "Krystal",
          last_name: "Decker",
          title: "Elit voluptate labore culpa nulla nisi ex laborum adipisicing enim nulla cillum sunt.",
          message: "Lorem do consectetur aliqua consequat veniam cillum. Aliqua cillum adipisicing fugiat quis ex esse sint occaecat aliqua commodo consequat commodo reprehenderit. Sint esse nulla incididunt eu dolor. Aliqua ad sunt incididunt esse culpa laborum cillum quis in aliquip ut ex. Lorem culpa nulla laborum ipsum commodo et reprehenderit deserunt do nostrud irure enim adipisicing. Cillum Lorem ea laborum amet do cillum id ea labore ullamco non aliqua deserunt ut. Ut pariatur ea mollit aliquip id incididunt exercitation tempor amet consequat.\r\n"
      },
      {
          id: 32,
          date: "17/01/2016 09:05",
          origin: "Application",
          type: "Notification",
          flag: "New",
          application: "EPC",
          first_name: "Gallegos",
          last_name: "Christian",
          title: "Officia officia aute culpa consectetur.",
          message: "Ex fugiat ipsum laboris sit laboris incididunt. Adipisicing laborum in sunt qui adipisicing nisi pariatur aute irure occaecat et deserunt. Labore do proident ea cillum minim qui eiusmod nulla ullamco voluptate incididunt. Excepteur pariatur culpa commodo minim aliqua reprehenderit voluptate aliqua cupidatat eu enim consectetur elit. In irure est veniam enim labore nisi aliqua. Do mollit deserunt incididunt nostrud cillum sunt. Labore eu minim est eu aliqua ullamco deserunt.\r\n"
      },
      {
          id: 33,
          date: "23/02/2016 06:34",
          origin: "User",
          type: "Chat",
          flag: "Viewed",
          application: "Direct Service",
          first_name: "Doreen",
          last_name: "Baxter",
          title: "Quis mollit mollit proident voluptate ad eu excepteur cupidatat est qui cillum labore cupidatat.",
          message: "Sint culpa sit exercitation voluptate incididunt non nisi in voluptate commodo. Velit reprehenderit cupidatat ad commodo adipisicing non minim velit ullamco cillum. Eu laborum voluptate enim cillum qui. Voluptate do sunt nisi do occaecat veniam mollit. Incididunt dolore proident velit enim laboris eu commodo ullamco in ut. Mollit labore dolor elit commodo dolor mollit ea id est laboris duis ex.\r\n"
      },
      {
          id: 35,
          date: "15/02/2016 02:15",
          origin: "User",
          type: "Notification",
          flag: "New",
          application: "QMS",
          first_name: "Ortiz",
          last_name: "Ferguson",
          title: "Enim labore anim elit ipsum eiusmod consectetur.",
          message: "Mollit deserunt cillum non nulla magna ad exercitation proident laborum. Occaecat tempor sit id aute sint do nostrud ipsum minim aute elit aliquip ipsum. Ipsum ea quis dolor reprehenderit ex velit aute cupidatat ad Lorem dolor nisi est enim. Et labore Lorem pariatur ut ut esse nulla cillum. Aliquip sint dolor ad ex amet anim reprehenderit consequat anim nisi voluptate commodo. Cillum reprehenderit ullamco culpa ad ipsum fugiat officia aliquip. Deserunt quis aute pariatur aute exercitation et ex quis anim irure cupidatat.\r\n"
      },
      {
          id: 36,
          date: "14/02/2016 01:12",
          origin: "Application",
          type: "Chat",
          flag: "Viewed",
          application: "Prac",
          first_name: "Marci",
          last_name: "Keller",
          title: "Pariatur fugiat incididunt consectetur et elit ad est cillum aute velit commodo.",
          message: "Fugiat labore do laboris do. Exercitation Lorem nisi adipisicing veniam labore sit sunt nisi amet ut consectetur do. Consequat sunt magna tempor dolor.\r\n"
      },
      {
          id: 37,
          date: "04/01/2016 07:27",
          origin: "User",
          type: "Chat",
          flag: "Viewed",
          application: "Solutions",
          first_name: "Bates",
          last_name: "Le",
          title: "Nulla esse in sit excepteur laboris voluptate esse tempor dolor aliquip.",
          message: "Minim eiusmod labore consequat aute elit labore fugiat amet anim cupidatat occaecat nostrud sunt consequat. Dolor est adipisicing pariatur nostrud proident pariatur est duis. Sit anim consequat adipisicing minim veniam mollit dolore. Aliquip sint ea duis adipisicing quis Lorem elit incididunt esse ad proident. Esse deserunt non est laboris veniam qui quis enim minim fugiat pariatur incididunt nulla.\r\n"
      },
      {
          id: 38,
          date: "01/01/2016 09:51",
          origin: "Application",
          type: "Message",
          flag: "Viewed",
          application: "Prac",
          first_name: "Hatfield",
          last_name: "Sampson",
          title: "Est velit officia elit anim aliquip.",
          message: "Labore voluptate nisi ullamco eu enim pariatur excepteur pariatur eu excepteur. Consectetur sit elit eiusmod ut. Nisi ex ex non officia eiusmod. Et occaecat adipisicing nisi irure irure occaecat tempor. Et sit adipisicing officia ex culpa officia magna nostrud ex. Enim et dolore pariatur ut officia elit voluptate nostrud proident.\r\n"
      },
      {
          id: 39,
          date: "17/01/2016 03:34",
          origin: "Application",
          type: "Chat",
          flag: "New",
          application: "Warranty",
          first_name: "Morales",
          last_name: "Frank",
          title: "Minim culpa commodo aute aliquip dolore ullamco.",
          message: "Do enim quis ipsum laboris ut qui dolor pariatur irure adipisicing. Minim commodo sunt sit labore. Proident elit dolor cillum labore.\r\n"
      },
      {
          id: 40,
          date: "25/02/2016 01:25",
          origin: "User",
          type: "Chat",
          flag: "Viewed",
          application: "Direct Service",
          first_name: "Tate",
          last_name: "Whitley",
          title: "Do occaecat elit irure esse exercitation enim adipisicing aliquip consectetur est ut culpa.",
          message: "Enim commodo proident esse aliquip nostrud dolor eu. Commodo magna minim dolor proident ex labore reprehenderit esse proident est. Id nostrud irure nulla do exercitation cillum quis. Voluptate qui occaecat nulla excepteur proident.\r\n"
      },
      {
          id: 41,
          date: "16/02/2016 07:52",
          origin: "User",
          type: "Message",
          flag: "Viewed",
          application: "QMS",
          first_name: "Anita",
          last_name: "Gordon",
          title: "Irure cupidatat dolore anim nisi deserunt exercitation ea veniam ad ea magna.",
          message: "Ex ullamco eu culpa dolor excepteur incididunt cupidatat sint fugiat laborum eiusmod et cillum. Duis ut irure nisi ut quis qui consectetur amet anim velit. Magna consequat labore enim nulla nostrud cupidatat consectetur aliquip eiusmod ut sunt. Aliquip consectetur in labore sit mollit et. Velit mollit tempor cupidatat exercitation est.\r\n"
      }
    ]
};







